import { PermissionService } from './../../../service/permission.service';
import { ObjectNames } from './../../../modules/shared/constants/object.names';
import { AppMainService } from './../../../app-main.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SavedSearchNS } from '../../saved-searches/models/saved-search.models';
import { FormControl } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { WorkflowService } from '../services/workflow.service';
import { WorkflowActionModules, WorkflowActionNames, WorkflowActionTypeList, WorkflowExecutionStatusList, WorkflowMessages } from '../models/workflow.static';
import { WorkflowModelsNS } from '../models/add-update-workflow.models';
import * as moment from "moment";
import { AppMainComponent } from 'src/app/app.main.component';
import { Status } from 'src/app/models/statusEnums';
import { prepareSavedSearchAddEditFilter } from '../../saved-searches/helpers/prepare-saved-searh-filter.helper';
import { prepareSavedSearchRuleValues } from '../../saved-searches/helpers/prepare-saved-search-rule-values.helper';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { DataTypeWithOperatorNS } from '../../saved-searches/models/saved-search.static';
import { LocalDatePipe } from '../../../modules/shared/pipes/local-date.pipe';
import { removeHTMLTags } from 'src/app/modules/shared/helpers/remove-html-tags.helper';
import { Router } from '@angular/router';
import { GlobalSearchPath } from 'src/app/modules/shared/constants/global-search-path';
import { TransactionNames } from '../../../finance/constants/constants';
@Component({
    selector: 'app-workflow-details',
    templateUrl: './workflow-details.component.html',
    styleUrls: ['./workflow-details.component.scss'],
    providers: [LocalDatePipe]
})
export class WorkflowDetailsComponent implements OnInit, OnChanges, OnDestroy {

    @Input() selectedWorkflowBlock: any;
    @Input() fromQuery: boolean;
    @Output() viewClosed = new EventEmitter<boolean>();
    @Output() loadList = new EventEmitter<boolean>();
    @Output() reloadList = new EventEmitter<boolean>();
    @Output() showEditWorkflow = new EventEmitter<'Copy'|'View'|'Edit'>();
    @Output() deleteSavedSearch = new EventEmitter<any>();


    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    menuItems: any[] = [];
    configMenuItemsCM: any[] = []
    selectedTabIndex: number = 0;

    detailsBlockCols: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
        { field: 'sequenceNumber', header: 'Id. No.', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'name', header: 'Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'objectName', header: 'Module Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'channelName', header: 'Channel Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'createdDate', header: 'Created Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
        { field: 'lastUpdated', header: 'Last Updated Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
        { field: 'workflowType', header: 'Workflow Type', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'triggerOn', header: 'Criteria', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'workflowConditionCount', header: 'Conditions', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'workflowActionCount', header: 'Actions', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'status', header: 'Status', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'validDate', header: 'Valid From Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' }
    ];


    //History
    historyCols: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
        { field: 'workflowTriggerType', header: 'Trigger Type', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'workflowActionType', header: 'Action Type', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'occurrenceType', header: 'Occurence Type', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'executionDuration', header: 'Execution Duration', show: true, value: 'duration', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'executionStatus', header: 'Execution Status', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'executedByName', header: 'Executed By', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' }
    ];

    //History
    selectedDetailsCols: SavedSearchNS.IColumn[] = [];
    historyDetailsCols: SavedSearchNS.IColumn[] = [
        { field: 'Lead Name', header: 'Lead Name', show: true, value: 'name', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'First Name', header: 'First Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'Last Name', header: 'Last Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'CreatedDate', header: 'Created Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
        { field: 'UpdatedDate', header: 'Updated Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
    ];

    opportunityHistoryCols: SavedSearchNS.IColumn[] = [
        { field: 'sequenceNumber', header: 'Opportunity ID', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'name', header: 'Opportunity Name', show: true, value: 'name', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'accountName', header: 'Account Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'stageName', header: 'Opportunity Stage', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'expectedDate', header: 'Close Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
        { field: 'CreatedDate', header: 'Created Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
        { field: 'UpdatedDate', header: 'Updated Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
    ];

    productHistoryCols: SavedSearchNS.IColumn[] = [
        { field: 'Item No', header: 'Item No', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'Created Date', header: 'Created Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
        { field: 'Updated Date', header: 'Updated Date', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'date' },
    ];

    //List
    searchControl = new FormControl();
    moduleSearchValue = '';
    gridState: any = {};

    workflowHistoryResults: WorkflowModelsNS.WorkflowHistoryDetails[] = [];
    noWfFindOrLoadingText = 'No Event History Found.';
    pageSize: number = 15;
    totalRecords: number = 0;
    tableShowMore: number[] = [15, 30, 50, 100];
    first: number = 0;

    selectedHistory: WorkflowModelsNS.WorkflowHistoryDetails;
    //History Dialog
    displayHistoryDetails: boolean = false;
    historyConditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[] = [];
    actionHistoryResults: any[] = [];

    displayDetailPopup = false;
    popupDataId: number = 0;
    popupModuleType: string = '';
    popupHeader: string = '';


    actionTypeList: any[] = [];
    selectedActionType: any = null;

    executionStatusList: any[] = [];
    selectedExecutionStatus: any = null;

    workflowDetails: WorkflowModelsNS.WorkflowDetails;
    executionStatus: WorkflowModelsNS.WorkflowExecutionStatus = 0;
    workflowValidExpired: boolean = false;
    workflowValidExpiredText: string = "";
    workflowJobId: string = "";
    taskSchedulerSubmitLoading: boolean = false;
    workflowExecutionStatus = WorkflowModelsNS.WorkflowExecutionStatus;
    workflowOccurrenceTypes = WorkflowModelsNS.WorkflowOccurrenceTypsEnum;
    workflowTriggerTypeEnum = WorkflowModelsNS.TriggerTypeEnum;
    workflowUpdateRecordOfferTypes = WorkflowModelsNS.WorkflowUpdateRecordOfferTypes;
    notificationType: number;
    notificationTypeEnum = WorkflowModelsNS.WorkflowNotificationTypeEnum;

    //For Condition Showing
    occurrenceBases = [
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Years, name:"Years" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Months, name:"Months" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days, name:"Days" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Hours, name:"Hours" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Minutes, name:"Minutes" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Seconds, name:"Seconds" },
    ];

    scheduleTypesEnum = WorkflowModelsNS.WorkflowScheduleTypesEnum;

    //Static Data
    conditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[] = [];
    ruleData: SavedSearchNS.IRuleList[] = [];
    actionModules: any[] = WorkflowActionModules;
    selectedActionModule: any = null;

    //Dropdown list value
    users: any[] = [];
    deleteRecordStatusNames: string[] = ['','Active','In Active','Delete'];
    startBaseFields = [
        {
            name: 'Execution Date',
            fieldName: 'ExecutionDateTime'
        }
    ];
    addOrSubstractBases = [
        { id: 2, name:"After" },
        { id: 1,name:"Before" },
    ];
    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];

    conditionTemp: WorkflowModelsNS.WorkflowAddedEditConditionGroup;
    actionType: 'instant'|'timedependent' = 'instant';
    timeDependentIndex: number;
    selectedActionTask: WorkflowModelsNS.WorkflowAddEditActionTask = null;
    selectedTaskIndex: number = -1;
    displayAddTask: boolean = false;
    selectedActionEmail: WorkflowModelsNS.WorkflowAddEditActionEmail = null;
    selectedEmailIndex: number = -1;
    displayAddEmailAlert: boolean = false;
    selectedActionField: any = null;
    selectedFieldIndex: number = -1;
    displayUpdateField: boolean = false;
    displayCreateRecord: boolean = false;
    selectedActionRecord: WorkflowModelsNS.WorkflowAddEditActionCreateRecord = null;
    selectedRecordIndex: number = -1;
    displayUpdateRecord: boolean = false;
    selectedActionUpdateRecord: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord = null;
    selectedUpdateRecordIndex: number = -1;
    displayAddApproval: boolean = false;
    selectedActionApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[] = [];
    selectedModule: any;
    selectedTemplate: any;

    /* Permission */
    readPermission: boolean;
    writePermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    exportPermission: boolean;

    accountDetailsRouteNavigationFor: string[] = ['Account','Lead','Opportunity'];
    globalSearchPath = GlobalSearchPath;

    //View Popup
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    displayLeadViewEdit: boolean = false;
    selectedLeadId: number = 0;
    displayOpportunityViewEdit: boolean = false;
    opportunityEditViewId: number = 0;

    transactionNames = TransactionNames;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";
    eventBasedWorkflowType: number[] = [1,2,3];

    workflowConversionTypeNames = WorkflowModelsNS.WorkflowConversionTypeNames;

    constructor(
        private localDatePipe: LocalDatePipe,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private workflowService: WorkflowService,
        public app: AppMainComponent,
        private permissionService: PermissionService,
        private router: Router

    ) {
    }

    ngOnInit(): void {
        this.actionTypeList = WorkflowActionTypeList;
        this.selectedActionType = this.actionTypeList[0];
        this.executionStatusList = WorkflowExecutionStatusList;
        this.selectedExecutionStatus = this.executionStatusList[0];
        this.setPermissions();
        this.tableGlobalSearchInit();
        this.getUsers();
    }

    // Set permissions for read, write, edit, delete and export
    setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();

        if (userPermissions.length) {
            const userPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WORKFLOW);

            const modulePermission = userPermission ? userPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1) : null;

            this.readPermission = modulePermission && (modulePermission[0].permissionId == 1 && modulePermission[0].statusId == 1);
            this.writePermission = modulePermission && (modulePermission[1].permissionId == 2 && modulePermission[1].statusId == 1);
            this.editPermission = modulePermission && (modulePermission[2].permissionId == 3 && modulePermission[2].statusId == 1);
            this.deletePermission = modulePermission && (modulePermission[3].permissionId == 4 && modulePermission[3].statusId == 1);
            this.exportPermission = modulePermission && (modulePermission[4].permissionId == 5 && modulePermission[4].statusId == 1);
        }

        this.buildContextMenu();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedWorkflowBlock'] && changes['selectedWorkflowBlock']?.currentValue) {
            this.selectedWorkflowBlock = changes['selectedWorkflowBlock'].currentValue;
            this.selectedTabIndex = 0;
            this.selectedActionType = this.actionTypeList[0];
            this.selectedExecutionStatus = this.executionStatusList[0];
            this.workflowDetails = null;
            this.loadWorkflowDetails(this.selectedWorkflowBlock.id)
        }
    }

    getUsers() {
        this.users = this.app.usersList;
    }

    buildContextMenu(){
        this.configMenuItemsCM = [];

        let visible: boolean = !!(this.executionStatus==this.workflowExecutionStatus.Pending || !this.selectedWorkflowBlock?.jobId);

        this.configMenuItemsCM.push(
            {
                label: 'View',
                icon: 'pi pi-list',
                command: () => {
                    this.showEditWorkflow.emit('View');
                }
            },
            {
                label: 'Edit',
                icon: 'pi pi-pencil',
                visible: this.editPermission,
                disabled: !visible,
                command: () => {
                    this.showEditWorkflow.emit('Edit');
                }
            },
            {
                label: 'Make Copy',
                icon: 'pi pi-copy',
                visible: this.editPermission,
                command: () => {
                    this.showEditWorkflow.emit('Copy');
                }
            },
            {
                label: 'Delete',
                icon: 'pi pi-trash',
                visible: this.deletePermission,
                disabled: !visible,
                command: () => {
                    this.deleteSavedSearch.emit(this.selectedWorkflowBlock);
                }
            },
        );
    }

    loadWorkflowDetails(workflowId: number) {
        this.appMainService.isShowSpinner('LoadWorkflowDetails');
        this.workflowService.getWorkflowById(workflowId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('LoadWorkflowDetails');
                this.workflowDetails = response;
                this.workflowDetails.nextStartDate = this.getNextStartDate(this.workflowDetails);
                this.executionStatus = this.workflowDetails.executionStatus;
                this.workflowJobId = this.workflowDetails.jobId;
                this.buildContextMenu();
                this.setWorkflowEditDetails();
            },
            error: (error) => {
                this.appMainService.isHideSpinner('LoadWorkflowDetails');
                this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.detailsErrorMsg });
            },
            complete: () => {

            }
        })
    }

    getNextStartDate(workflowDetails: WorkflowModelsNS.WorkflowDetails) {

        let nextStartDate: string = null;

        if (workflowDetails?.lastStartDate) {

            switch (workflowDetails.occurrenceBase) {
                case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Years:
                    return nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 'y').toISOString();
                    break;
                case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Months:
                    return nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 'M').toISOString();
                    break;
                case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days:
                    return nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 'd').toISOString();
                    break;
                case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Hours:
                    return nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 'h').toISOString();
                    break;
                case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Minutes:
                    return nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 'm').toISOString();
                    break;
                case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Seconds:
                    return nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 's').toISOString();
                    break;
            }


            nextStartDate = moment.utc(workflowDetails?.lastStartDate).add(workflowDetails.occurrenceValue, 'd').toISOString();
        }

        return nextStartDate;
    }

    //#region History

    tableGlobalSearchInit() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe(value => {
                this.moduleSearchValue = value.trim() ? value.trim() : '';
                this.onGlobalSearch();
            });
    }

    onGlobalSearch() {
        this.resetWorkflowPagination();
        this.getWorkflowHistory(1, 15);
    }

    onFilterChange(event: LazyLoadEvent): void {
        const filters = [];
        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value
            });
        }
        this.gridState['filters'] = filters
    }

    getWorkflowHistoryByFilter(event: LazyLoadEvent): void {
        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getWorkflowHistory(1, 15);
                return;
            }
        }

        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;
        //if sort exist
        if (event.sortField) {
            const temp = {
                field: event.sortField,
                order: event.sortOrder
            }
            this.gridState['sort'] = temp;
        }
        //if column filter exist
        if (event.filters) {
            this.onFilterChange(event);
        }

        this.getWorkflowHistory(pageNumber, pageSize);
    }

    getWorkflowHistory(pageNumber: number, pageSize: number) {

        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            let searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';
            options.filter = {
                field: filterColumns.join(','),
                value: searchValue
            }
        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        options.moduleSearchValue = this.moduleSearchValue.length ? this.moduleSearchValue.trim() : '';
        options.workflowActionType = this.selectedActionType?.id || 0;
        options.executionStatus = this.selectedExecutionStatus?.id || 0;

        this.appMainService.isShowSpinner('getWorkflowHistoryList');
        this.workflowService.getWorkflowExecutionHistory(this.selectedWorkflowBlock?.id, pageNumber, pageSize, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('getWorkflowHistoryList');

                let data = response.body == null ? [] : response.body;
                let headers = JSON.parse(response.headers.get('X-Pagination'));
                headers = headers == null ? [] : headers;
                this.totalRecords = headers['TotalCount'] || 0;

                this.workflowHistoryResults = data||[];
                this.workflowHistoryResults.map(history=>{
                    if(history?.objectName)
                        history.workflowActionType = `${history.workflowActionType} (${history?.objectName})`;
                })
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getWorkflowHistoryList');
            }
        })
    }

    resetWorkflowPagination() {
        this.first = 0;
    }

    filterByActionType() {
        this.resetWorkflowPagination();
        this.getWorkflowHistory(1, 15);
    }

    filterByExecutionStatus(){
        this.resetWorkflowPagination();
        this.getWorkflowHistory(1, 15);
    }

    onRowSelect($event) {
        this.openHistoryDetails(this.selectedHistory);
    }

    onRowUnselect($event) { }

    //#endregion

    //#region Task Scheduler

    runWorkflowTaskScheduler() {

        this.confirmationService.confirm({
            message: 'Are you sure want to run this workflow scheduler?',
            header: 'Run Scheduler',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.taskSchedulerSubmitLoading = true;
                this.workflowService.runWorkflowScheduler(this.workflowDetails.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response) => {
                        this.taskSchedulerSubmitLoading = false;
                        this.messageService.add({ severity: WorkflowMessages.success.toLowerCase(), summary: WorkflowMessages.success, detail: WorkflowMessages.taskRunningSuccess });
                        // this.loadWorkflowDetails(this.workflowDetails.id);

                        if (response.body) {
                            this.executionStatus = this.workflowExecutionStatus.Executing;
                            this.workflowJobId = response.body;
                            // this.refreshDetails();
                            this.reloadList.emit(true);
                        }
                    },
                    error: (error) => {
                        this.taskSchedulerSubmitLoading = false;
                        this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.taskRunningFailed });
                    }
                })
            },
            reject: () => {

            }
        });


    }

    stopWorkflowTaskScheduler() {
        if (this.workflowJobId) {

            this.confirmationService.confirm({
                message: 'Are you sure want to stop this workflow scheduler?',
                header: 'Stop Scheduler',
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.taskSchedulerSubmitLoading = true;
                    this.workflowService.removeWorkflowScheduler(this.workflowJobId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                        next: (response) => {
                            this.taskSchedulerSubmitLoading = false;
                            this.messageService.add({ severity: WorkflowMessages.success.toLowerCase(), summary: WorkflowMessages.success, detail: WorkflowMessages.taskStopSuccess });
                            // this.loadWorkflowDetails(this.workflowDetails.id);


                            this.executionStatus = this.workflowExecutionStatus.Pending;
                            this.workflowJobId = null;
                            // this.refreshDetails();
                            this.reloadList.emit(true);

                        },
                        error: (error) => {
                            this.taskSchedulerSubmitLoading = false;
                            this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.taskStopFailed });
                        }
                    })
                },
                reject: () => {

                }
            });


        }
    }

    //#endregion

    changeTab(e) {
        if (e.index == 1) {

        }
    }

    refreshDetails(){
        this.loadWorkflowDetails(this.selectedWorkflowBlock.id);

        if (this.selectedTabIndex == 1) {
            this.resetWorkflowPagination();
            this.getWorkflowHistory(1, 15);
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    closeSplitView() {
        this.viewClosed.emit();
    }

    openHistoryDetails(historyDetails: WorkflowModelsNS.WorkflowHistoryDetails){
        const actionsList: string[] = WorkflowActionNames;
        const historyConditionGroup = this.conditionGroup.filter(condition=> condition.conditionId==historyDetails.workflowConditionId)||[];
        this.historyConditionGroup = ParseHelper.DeepCopy(historyConditionGroup);
        this.historyConditionGroup.map(addedCondition=>{
            if(addedCondition.instantActions.id==historyDetails.workflowActionId){
                actionsList.map(actionName=>{
                    if(addedCondition.instantActions?.[actionName] && addedCondition.instantActions?.[actionName]?.length){
                        addedCondition.instantActions[actionName] =  addedCondition.instantActions[actionName].filter(c=> (actionName === "workflowActionUpdateFields" && c.objectId) ? c.objectId === historyDetails.objectId : c.id === historyDetails.workflowActionTaskId);
                    }
                });
            }else{
                addedCondition.instantActions = null;
            }

            addedCondition.timeDependentActions = addedCondition.timeDependentActions.filter(c=>c.id==historyDetails.workflowActionId);

            if(addedCondition.timeDependentActions.length>0){
                addedCondition.timeDependentActions.map(actionDetails=>{
                    actionsList.map(actionName=>{
                        if(actionDetails?.[actionName] && actionDetails?.[actionName]?.length){
                            actionDetails[actionName] =  actionDetails[actionName].filter(c=> (actionName === "workflowActionUpdateFields" && c.objectId) ? c.objectId === historyDetails.objectId : c.id === historyDetails.workflowActionTaskId);
                        }
                    });
                })
            }else{
                addedCondition.timeDependentActions = null;
            }
        });
        

        // this.historyDetailsCols[0].field = `${this.workflowDetails?.objectName} Name`;
        // this.historyDetailsCols[0].header = `${this.workflowDetails?.objectName} Name`;

        // switch (this.workflowDetails.objectId) {
        //     case LeadModuleId:
        //         this.selectedDetailsCols = ParseHelper.DeepCopy(this.historyDetailsCols);
        //         break;
        //     case AccountModuleId:
        //         this.selectedDetailsCols = ParseHelper.DeepCopy(this.historyDetailsCols);
        //         break;
        //     case OpportunityModuleId:
        //         this.selectedDetailsCols = ParseHelper.DeepCopy(this.opportunityHistoryCols);
        //         break;
        //     case ProductModuleId:
        //         this.selectedDetailsCols = ParseHelper.DeepCopy(this.productHistoryCols);
        //         break;
        //     default:
        //         break;
        // }

        this.actionHistoryResults = historyDetails?.taskData ? JSON.parse(historyDetails?.taskData)?.Result||[] : [];

        let navigationFields: string[] = [];

        if(['Lead','Account'].includes(this.workflowDetails?.objectName)){
            navigationFields = ['Lead Name','Account Name','Sales Order No','Estimate No','Invoice No','Invoice','CreditMemo','Estimate','SalesOrder','ConSONo','ConInvNo','Credit Memo'];
        }else if(['Opportunity'].includes(this.workflowDetails?.objectName)){
            navigationFields = ['name','Opportunity Name'];
        }else if([ObjectNames.SALES_ORDER.toString()].includes(this.workflowDetails?.objectName)){
            navigationFields = ['Sales Order No.'];
        }else{
            navigationFields = ['Item No','Invoice No.','Estimate No.'];
        }

        this.generateHistoryDetailsColumns(navigationFields,historyDetails);
        this.displayHistoryDetails = true;
    }

    generateHistoryDetailsColumns(navigationFields: string[], historyDetails: any){
        if(this.actionHistoryResults?.length>0){
            const historyDetailsObject = this.actionHistoryResults[0];
            const columns: SavedSearchNS.IColumn[] = [];
            const globalThis = this;


            if(historyDetails?.savedSearchColumnSetting){
                this.selectedDetailsCols = this.getColumnSettingsForTable(historyDetails?.savedSearchColumnSetting, navigationFields);

                Object.keys(historyDetailsObject).forEach(function(key, index) {
                    const fieldCheck = globalThis.selectedDetailsCols.find(x=> x.field==key);
                    if(fieldCheck){
                        fieldCheck.show = true;
                    }
                });
            }else{
                Object.keys(historyDetailsObject).forEach(function(key, index) {
                    if(!['id','trans_id'].includes(key.trim().toLowerCase())){
                        columns.push({
                            field: key,
                            name: key,
                            header: globalThis.prepareColumnNameFromField(key),
                            show: true,
                            value: navigationFields.includes(key.trim()) ? 'name' : key,
                            checked: false,
                            order: false,
                            moveable: false,
                            dataType: ['CreatedDate','UpdatedDate','Created Date','Updated Date','Last Updated Date','Close Date',
                                        'expectedDate','createdDate','Invoice Date','Invoice Due Date','Estimate Date','Expiration Date','Trans Created Date','Trans Last Updated Date'].includes(key.trim()) ? 'date' : 'string'
                        });
                    }
                });

                this.selectedDetailsCols = columns;
            }
        }
    }

    getColumnSettingsForTable(selectedColums: SavedSearchNS.SavedSearchColumnSetting[], navigationFields: string[]): any[] {
        let columns: SavedSearchNS.IColumn[] = [];

        if (selectedColums) {
            let i = 1;
            selectedColums?.map(f => {
                f?.fields?.map(x => {
                    //nested field
                    if (x?.nestedFields?.length > 0) {
                        x.nestedFields?.map(nestObj => {
                            columns.push(
                                {
                                    field: this.prepareColumnNameFromCriteria(nestObj.criteriaUsed),
                                    name: (nestObj?.name||nestObj?.fieldName||'').trim(),
                                    header: `${x?.name||x?.fieldName}: ${nestObj.labelName}`,
                                    dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.fieldName != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currencySymbol' : 'string',
                                    show: false,
                                    value: navigationFields.includes((nestObj?.name||nestObj?.fieldName||'').trim()) ? 'name' : null,
                                    checked: nestObj.isSelected,
                                    order: false,
                                    moveable: false,
                                });
                            i = i + 1;
                        });
                    }
                    else {
                        let name = (x?.name||x?.fieldName||'').trim();
                        if(['trans_CreatedDate','trans_UpdatedDate'].includes(x.fieldNameDB)){
                            name = `Trans ${name}`;
                        }

                        columns.push(
                            {
                                field: this.prepareColumnNameFromCriteria(x.criteriaUsed),
                                name: name,
                                header: x.labelName,
                                dataType: x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currencySymbol' : 'string',
                                show: false,
                                value: navigationFields.includes((x?.name||x?.fieldName||'').trim()) ? 'name' : null,
                                checked: x.isSelected,
                                order: false,
                                moveable: false,
                            });
                        i = i + 1;
                    }
                });
            });

            const defaultColumns: { fieldName: string; labelName: string }[] = [
                { fieldName: 'CreatedPONo', labelName: 'Created PO No' },
                { fieldName: 'CreatedBONo', labelName: 'Created BO No' },
                { fieldName: 'CreatedVCNo', labelName: 'Created VC No' },
                { fieldName: 'CreatedRPONo', labelName: 'Created RPO No' },
                { fieldName: 'ConSONo', labelName: 'Con SO No' },
                { fieldName: 'ConInvNo', labelName: 'Con Inv No' },
                { fieldName: 'Invoice', labelName: 'Invoice' },
                { fieldName: 'CreditMemo', labelName: 'Credit Memo' },
                { fieldName: 'Estimate', labelName: 'Estimate' },
                { fieldName: 'SalesOrder', labelName: 'Sales Order' },
                { fieldName: 'CreatedDate', labelName: 'Created Date' },
                { fieldName: 'UpdatedDate', labelName: 'Updated Date' },
                { fieldName: 'Status', labelName: 'Status' },
                { fieldName: 'Reason', labelName: 'Reason' },
                { fieldName: 'Comment', labelName: 'Comment' }
            ];
            
            defaultColumns.map(col => {
                columns.push({
                    field: col.fieldName,
                    name: col.fieldName,
                    header: col.labelName,
                    show: false,
                    value: navigationFields.includes(col.fieldName) ? 'name' : null,
                    checked: false,
                    order: false,
                    moveable: false,
                    dataType: ['CreatedDate', 'UpdatedDate'].includes(col.fieldName.trim()) ? 'date' : 'string'
                });
            });
        }
            

        return columns;
    }

    prepareColumnNameFromCriteria(str?: string) {
        return str?.length > 0 ? str[0].toLocaleLowerCase() + str.slice(1) : str;
    }

    prepareColumnNameFromField(str?: string){
        return str?.length > 0 ? str[0].toLocaleUpperCase()+str.slice(1) : str;
    }


    historyDialogClose(){
        this.displayHistoryDetails = false;
    }

    onRouteNavigation(rowData: any, field: string, fieldName: string) {
        if(this.accountDetailsRouteNavigationFor.includes(this.workflowDetails?.objectName)){
            if(['Sales Order No','Estimate No','Invoice No','Invoice','CreditMemo','Estimate','SalesOrder','ConInvNo','ConSONo','Credit Memo'].includes(fieldName)){
                this.navigateToTransactionTypeDetailsPage(rowData,field,fieldName);
            }else{
                this.setPopUpLinkData(rowData);
            }
        }else{
            this.navigateToDetailsPage(rowData,field);
        }
    }

    closeDetailsPopupDialog() {
        this.displayDetailPopup = false;
        this.popupDataId = 0;
        this.popupModuleType = '';
        this.popupHeader = '';
    }

    setPopUpLinkData(rowData: any) {
        const moduleName = this.workflowDetails.objectName;
        switch (moduleName) {
            case 'Lead':
                this.popupDataId = rowData?.Id ?? 0;
                this.openLeadViewEdit(this.popupDataId);
                break;
            case 'Account':
                this.popupDataId = rowData?.Id ?? 0;
                this.openAccountViewEdit(this.popupDataId);
                break;
            case 'Opportunity':
                this.popupDataId = rowData?.Id ?? 0;
                this.openOpportunityViewEdit(this.popupDataId);
                break;
            default:
                break;
        }
    }

    navigateToDetailsPage(rowData: any, field: string) {
        switch (this.workflowDetails.objectName) {
            case ObjectNames.PRODUCT:
                this.crmNavigation(this.globalSearchPath.Product, ObjectNames.PRODUCT, rowData?.Id, rowData[field]);
                break;
            case ObjectNames.SALES_ORDER:
                this.openInventoryOverview(this.transactionNames.SalesOrder, rowData?.Id, rowData[field]);
                break;
            case ObjectNames.INVOICE:
                this.openInventoryOverview(this.transactionNames.Invoice, rowData?.Id, rowData[field]);
                break;
            case ObjectNames.ESTIMATE:
                this.openInventoryOverview(this.transactionNames.Estimate, rowData?.Id, rowData[field]);
            default:
                break;
        }
    }

    navigateToTransactionTypeDetailsPage(rowData: any, field: string, fieldName: string) {
        switch (fieldName) {
            case 'CreditMemo':
            case 'Credit Memo':
                this.openInventoryOverview(this.transactionNames.CreditMemo, 0, rowData[field]);
                break;
            case 'SalesOrder':
            case 'ConSONo':
            case 'Sales Order No':
                this.openInventoryOverview(this.transactionNames.SalesOrder, 0, rowData[field]);
                break;
            case 'Invoice':
            case 'ConInvNo':
            case 'Invoice No':
                this.openInventoryOverview(this.transactionNames.Invoice, 0, rowData[field]);
                break;
            case 'Estimate':
            case 'Estimate No':
                this.openInventoryOverview(this.transactionNames.Estimate,0, rowData[field]);
            default:
                break;
        }
    }

    crmNavigation(modulePath: string, moduleName: string, id: number, title: string, channelId: number = 0) {

        let queryParams: any = {
            id: id,
            module: moduleName,
            channelId: channelId||this.selectedTemplate.channelId,
            statusId: 1,
            globalSearch: true,
            data: removeHTMLTags(title)
        };

        const url = this.router.serializeUrl(this.router.createUrlTree([modulePath], {queryParams: queryParams}));
        window.open(url, '_blank');

        // this.router
        //     .navigateByUrl("/", { skipLocationChange: true })
        //     .then(() =>
        //         this.router.navigate([modulePath], {
        //             queryParams: queryParams
        //         })
        //     );
    }

    openInventoryOverview(moduleName: string, id: number, title: string){
        this.inventoryOverviewRefId = id;
        this.inventoryOverviewRefNumber = title;
        this.inventoryOverviewModule = moduleName;
        this.displayInventoryOverview = true;
    }

    openAccountViewEdit(accountId: number) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = accountId;
    }

    openLeadViewEdit(leadId: number) {
        this.displayLeadViewEdit = true;
        this.selectedLeadId = leadId;
    }

    openOpportunityViewEdit(opportunityId: number) {
        this.displayOpportunityViewEdit = true;
        this.opportunityEditViewId = opportunityId;
    }

    closeViewPopup(){
        this.displayInventoryOverview = false;
        this.displayAccountViewEdit = false;
        this.displayLeadViewEdit = false;
        this.displayOpportunityViewEdit = false;
    }

    //#region ***Condition Details***
    setWorkflowEditDetails(){

        /**
         * If workflow is to show from query, then set the missing details
         */
        if(this.fromQuery){
            this.selectedWorkflowBlock = {
                ...this.workflowDetails,
                conditions: this.workflowDetails?.workflowConditions?.length ?? 0,
                lastUpdated: this.workflowDetails?.updatedDate ? this.localDatePipe.transform(this.workflowDetails.updatedDate) : null,
                createdDate: this.workflowDetails?.createdDate ? this.localDatePipe.transform(this.workflowDetails.createdDate) : null,
                status: this.workflowDetails?.statusId == 1 ? 'Active' : 'Inactive',
                workflowType: this.eventBasedWorkflowType.includes(this.workflowDetails?.triggerType) ? 'Event Based' : 'Time Based',
            }
        }else{
            this.selectedWorkflowBlock = {
                ...this.workflowDetails,
                ...this.selectedWorkflowBlock
            }
        }

        this.conditionGroup = [];

        this.selectedModule = {
            objectId: this.workflowDetails.objectId,
            name: this.workflowDetails.objectName
        };

        this.selectedTemplate = {
            id: this.workflowDetails.channelId,
            channelId: this.workflowDetails.channelId,
            name: this.workflowDetails.channelName
        };

        const startDateText = this.workflowDetails.validFromDate ?  this.localDatePipe.transform(this.workflowDetails.validFromDate) : '';
        const endDateText = this.workflowDetails.validToDate ?  this.localDatePipe.transform(this.workflowDetails.validToDate) : '';

        const validDateCol = this.detailsBlockCols.findIndex(field=> field.field=='validDate');
        if(endDateText){
            this.detailsBlockCols[validDateCol]['labelname'] = 'Valid Date';
        }else{
            this.detailsBlockCols[validDateCol]['labelname'] = 'Valid From Date';
        }
        this.selectedWorkflowBlock['scheduledDate'] =  this.workflowDetails?.scheduledDate;
        this.selectedWorkflowBlock['validDate'] = `${startDateText}${(startDateText && endDateText)? ' to ' : ''}${endDateText}`;
        this.selectedWorkflowBlock['createdByUserName'] = this.workflowDetails?.createdByUserName;
        this.selectedWorkflowBlock['lastUpdatedByUserName'] = this.workflowDetails?.lastUpdatedByUserName;
        this.checkWorkflowValidDate();

        if(this.workflowDetails.triggerType==4){
            let workflowCriteria = `Workflow run every ${ this.workflowDetails.occurrenceValue } ${ this.workflowOccurrenceTypes[this.workflowDetails.occurrenceBase] }`;
            if(this.workflowDetails?.occurrenceType==WorkflowModelsNS.WorkflowScheduleTypesEnum.Once){
                workflowCriteria = 'Workflow will run Once';
            }

            this.selectedWorkflowBlock['triggerOn'] = workflowCriteria;
        }

        this.workflowDetails.workflowConditions.sort((a, b)=> b.order - a.order).map((addedCondition, index)=>{

            const constionRefId: number = this.conditionGroup.length>0 ? this.conditionGroup[0].id + 1 : 1;
            const addedInstantAction = addedCondition?.workflowActions.find(actionDetails=>actionDetails.occurrenceType===WorkflowModelsNS.OccurrenceTypeEnum.INSTANT && actionDetails.statusId==Status.Active);
            const conditionData: WorkflowModelsNS.WorkflowAddedEditConditionGroup = {
                id: constionRefId,
                conditionId: addedCondition.id,
                conditionNumber: index+1,
                statusId: addedCondition?.statusId||1,
                type: addedCondition.isMannualCondition ? 'manual' : 'savedsearch',
                savedSearchId: addedCondition.saveSearchId,
                isCombinational: addedCondition?.savedSearchInfo?.isCombinational||false,
                ruleCombination: addedCondition?.savedSearchInfo?.ruleCombination||"",
                validData: true,
                errorMsg: "",
                ruleData: [],
                instantActions: {
                    ...addedInstantAction,
                    executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                    workflowActionTasks: [],
                    workflowActionEmails: [],
                    workflowActionUpdateFields: [],
                    workflowActionCreateRecords: [],
                    workflowActionUpdateRecords: [],
                    workflowActionConvertToInvoices: [],
                    workflowActionDeleteRecords: [],
                    workflowActionApprovals: []
                },
                timeDependentActions: []
            }

            addedCondition.workflowActions.filter(actionDetails=>actionDetails.statusId==Status.Active).map((actionDetails)=>{

                if(actionDetails?.workflowActionTasks){
                    actionDetails.workflowActionTasks = actionDetails.workflowActionTasks.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionEmails){
                    actionDetails.workflowActionEmails = actionDetails.workflowActionEmails.filter(email=> email.statusId==Status.Active)||[];

                    actionDetails.workflowActionEmails.map(emailDetails=>{

                        if(emailDetails.workflowEmailAttachments?.length>0){
                            const addedAttachments: WorkflowModelsNS.EmailTemplateAttachments[] = [];
                            emailDetails.workflowEmailAttachments.map(attachmentDetails=>{
                                attachmentDetails = {
                                    ...attachmentDetails,
                                    oldAttachment: attachmentDetails.attachment,
                                    attachment: null,
                                }

                                addedAttachments.push(attachmentDetails);
                            })

                            emailDetails.workflowEmailAttachments = addedAttachments;
                        }

                    })
                }

                if(actionDetails?.workflowActionUpdateFields){
                    actionDetails.workflowActionUpdateFields = actionDetails.workflowActionUpdateFields.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionCreateRecords){
                    actionDetails.workflowActionCreateRecords = actionDetails.workflowActionCreateRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionUpdateRecords){
                    actionDetails.workflowActionUpdateRecords = actionDetails.workflowActionUpdateRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionApprovals){
                    actionDetails.workflowActionApprovals = actionDetails.workflowActionApprovals.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionConvertToInvoices){
                    actionDetails.workflowActionConvertToInvoices = actionDetails.workflowActionConvertToInvoices.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionDeleteRecords){
                    actionDetails.workflowActionDeleteRecords = actionDetails.workflowActionDeleteRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails.occurrenceType===WorkflowModelsNS.OccurrenceTypeEnum.INSTANT){
                    if(actionDetails?.workflowActionTasks?.length>0)
                    conditionData.instantActions.workflowActionTasks = [...conditionData.instantActions.workflowActionTasks,...actionDetails.workflowActionTasks];

                    if(actionDetails?.workflowActionEmails?.length>0)
                    conditionData.instantActions.workflowActionEmails = [...conditionData.instantActions.workflowActionEmails,...actionDetails.workflowActionEmails];

                    if(actionDetails?.workflowActionUpdateFields?.length>0)
                    conditionData.instantActions.workflowActionUpdateFields = [...conditionData.instantActions.workflowActionUpdateFields,...actionDetails.workflowActionUpdateFields];

                    if(actionDetails?.workflowActionCreateRecords?.length>0)
                    conditionData.instantActions.workflowActionCreateRecords = [...conditionData.instantActions.workflowActionCreateRecords,...actionDetails.workflowActionCreateRecords];

                    if(actionDetails?.workflowActionUpdateRecords?.length>0)
                    conditionData.instantActions.workflowActionUpdateRecords = [...conditionData.instantActions.workflowActionUpdateRecords,...actionDetails.workflowActionUpdateRecords];

                    if(actionDetails?.workflowActionApprovals?.length>0)
                    conditionData.instantActions.workflowActionApprovals = [...conditionData.instantActions.workflowActionApprovals,...actionDetails.workflowActionApprovals];

                    if(actionDetails?.workflowActionConvertToInvoices?.length>0)
                    conditionData.instantActions.workflowActionConvertToInvoices = [...conditionData.instantActions.workflowActionConvertToInvoices,...actionDetails.workflowActionConvertToInvoices];

                    if(actionDetails?.workflowActionDeleteRecords?.length>0)
                    conditionData.instantActions.workflowActionDeleteRecords = [...conditionData.instantActions.workflowActionDeleteRecords,...actionDetails.workflowActionDeleteRecords];
                }else{
                    const action: any = actionDetails;
                    const startDateBaseField = this.startBaseFields[0];
                    const occurrenceBase = this.occurrenceBases.find(c=>c.id===actionDetails.occurrenceBase)||this.occurrenceBases[2];
                    const selectedAddOrSubstractBase = actionDetails.occurrenceValue>=0 ? this.addOrSubstractBases[0] : this.addOrSubstractBases[1];
                    actionDetails.occurrenceValue = Math.abs(actionDetails.occurrenceValue);

                    conditionData.timeDependentActions.push({
                        ...action,
                        executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                        addOrSubstractBase: selectedAddOrSubstractBase.id,
                        addOrSubstractBaseName: selectedAddOrSubstractBase.name,
                        occurrenceBaseName: occurrenceBase?.name,
                        dateTimeFieldLabel: startDateBaseField.name,
                    });
                }
            })

            conditionData.ruleData = addedCondition.savedSearchInfo.savedSearchRule.map((rule: any)=>{

                let choice = this.choicesDD.find(x => x.name == rule.operator);
                let eachRule: SavedSearchNS.IRuleList = {
                    id: rule.id,
                    ruleNo: rule?.ruleNo,
                    module: null,
                    subModule: null,
                    template: { id: rule.templateId, templateName: rule.templateName, objectId: rule.objectId, channelId: 0, channelName: '', isActive: true },
                    filter: prepareSavedSearchAddEditFilter(rule),
                    operator: { id: 1, name: rule.equation },
                    value: rule.values,
                    value2: null,
                    choice: choice,
                    isMainModule: rule.isMainModule,
                    dataTypeWithOperator: this.getOperatorByDataTypeAddEdit(rule.dataType, rule.equation),
                    valueLists: [],
                    treeValueLists: [],
                    objectId: rule.objectId,
                    objectName: rule.objectName,
                    valueRefId: rule.valueRefId,
                    groupLabel: "",
                    groupChildren: "",
                    group: false,
                    filtersDD: [],
                    canEdit: true,
                    accountChannel: null,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                    customAttributeObjectId: rule?.customAttributeObjectId||null,
                    comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null,
                };
                //****Prepare Value
                // console.log(eachRule)
                const { value, value2 } = prepareSavedSearchRuleValues(eachRule, this.app.usersList);
                eachRule.value = value;
                eachRule.value2 = value2;
                return eachRule;
            })


            conditionData.instantActions.executionOrders.map(actionOrder=>{
                if(conditionData.instantActions?.[actionOrder.code]?.length>0){
                    actionOrder.executionOrder = conditionData.instantActions?.[actionOrder.code][0].executionOrder||0;
                }
            });
            conditionData.instantActions.executionOrders = conditionData.instantActions.executionOrders.sort((a,b)=> a.executionOrder - b.executionOrder);

            conditionData.timeDependentActions.map(timeDependentAction=>{
                timeDependentAction.executionOrders.map(actionOrder=>{
                    if(timeDependentAction?.[actionOrder.code]?.length>0){
                        actionOrder.executionOrder = timeDependentAction?.[actionOrder.code][0].executionOrder||0;
                    }
                });
                timeDependentAction.executionOrders = timeDependentAction.executionOrders.sort((a,b)=> a.executionOrder - b.executionOrder);
            });

            if(this.conditionGroup.length>0){
                this.conditionGroup.unshift(conditionData)
            }else{
                this.conditionGroup.push(conditionData)
            }


        })
    }

    getOperatorByDataTypeAddEdit(dataType: string, operator: string): DataTypeWithOperatorNS.ISavedSearchDataTypeWithOperator {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == dataType && x.Operator == operator);
        return selectedDataTypeAndOperator;
    }

    openTaskEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, taskDetails: WorkflowModelsNS.WorkflowAddEditActionTask, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        this.selectedActionTask = ParseHelper.DeepCopy(taskDetails);
        this.selectedTaskIndex = index;
        this.displayAddTask = true;
    }
    openEmailEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, emailDetails: WorkflowModelsNS.WorkflowAddEditActionEmail, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.notificationType = emailDetails?.notificationType||WorkflowModelsNS.WorkflowNotificationTypeEnum.EMAIL;
        this.selectedActionEmail = ParseHelper.DeepCopy(emailDetails);
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==emailDetails?.objectId)||null;
        this.selectedEmailIndex = index;
        this.displayAddEmailAlert = true;
    }
    openFieldEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, fieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.selectedActionField = ParseHelper.DeepCopy(fieldDetails);
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==fieldDetails?.objectId)||null;
        this.selectedFieldIndex = index;
        this.displayUpdateField = true;
    }

    openCreateRecordEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        this.selectedActionRecord = ParseHelper.DeepCopy(recordDetails);
        this.selectedRecordIndex = index;
        this.displayCreateRecord = true;
    }

    openUpdateRecordEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, recordDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.selectedActionUpdateRecord = ParseHelper.DeepCopy(recordDetails);
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==recordDetails?.objectId)||null;
        this.selectedUpdateRecordIndex = index;
        this.displayUpdateRecord = true;
    }

    openApprovalEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, selectedApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[]){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        this.selectedActionApprovals = ParseHelper.DeepCopy(selectedApprovals);
        this.displayAddApproval = true;
    }

    checkWorkflowValidDate(){
        const nowDate = new Date().toISOString();
        this.workflowValidExpired = false;

        const fromdate = this.workflowDetails.validFromDate ? moment.utc(this.workflowDetails.validFromDate) : null;
        const todate = this.workflowDetails.validToDate ? moment.utc(this.workflowDetails.validToDate) : null;
        const nowdate =  moment.utc(nowDate);
        const fromDateValid: boolean = fromdate ? nowdate.diff(fromdate, 'seconds')>0 : true;
        const toDateValid: boolean = todate ? nowdate.diff(todate, 'seconds')<0 : true;

        if(!fromDateValid){
            this.workflowValidExpired = true;
            this.workflowValidExpiredText = 'Not Started';
        }

        if(!toDateValid){
            this.workflowValidExpired = true;
            this.workflowValidExpiredText = 'Expired';
        }
    }

    //#endregion ***Condition Details End***

    checkActions(actionDetails: any){
        return WorkflowModelsNS.WorkflowActionDefaultOrders.some(action=> actionDetails?.[action.code]?.length>0);
    }

    updateRecordCount(recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord){
        return recordDetails?.workflowCreateRecordProducts.filter(p=> p.statusId==Status.Active)?.length||0;
    }

}
